import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Icon,
  FormGroup,
  FormField,
  Button,
  Dropdown,
  Input
} from 'semantic-ui-react'

const CardEditMedOrderUX = (props: any) => {
    return(
      <div
        id="CardEditMedOrderUX-div-0"
        style={{width:"100%", padding: "10px",  height: "100%"}}>
        <div
          id="CardEditMedOrderUX-div-1"
          style={{display: props.showHeader? "flex": "none", justifyContent: "space-between", alignItems: "center"}}>

          <div
            id="CardEditMedOrderUX-div-3"
            style={{fontSize: "1.15rem", fontWeight: "bold", padding: "2.5px 0", color: "#0072BC"}}>
            แก้ไขคำสั่งยา
          </div>
          <div
            id="CardEditMedOrderUX-div-4"
            style={{cursor: "pointer"}}>

            <Icon
              className="red"
              id="CardEditMedOrderUX-Icon-5"
              name="close"
              onClick={props.onClose}>
            </Icon>
          </div>
        </div>
        <div
          className="ui divider"
          id="CardEditMedOrderUX-div-2"
          style={{display: props.showHeader? "": "none"}}>

        </div>
        <div
          className="ui form"
          id="CardEditMedOrderUX-div-6"
          style={{ position: "relative", padding: props.showHeader? "0 0.5rem": ""}}>

          <div
            id="CardEditMedOrderUX-div-120"
            style={{display: props.openCalCulator ? "inline" : "none", position:"absolute", width:"80%", height:"180px", right:"16px", top:"-35rem"}}>
            {props.pediatricUI}
          </div>
          <FormGroup
            id="CardEditMedOrderUX-FormGroup-8"
            style={{marginBottom: "0.5rem"}}>
            <FormField
              className="--override-disabled --grey"
              id="CardEditMedOrderUX-FormField-12"
              width={6}>
              <FormField
                className="required"
                id="CardEditMedOrderUX-FormField-13">
                <label
                  id="CardEditMedOrderUX-label-14">
                  Drug
                </label>
              </FormField>
              <div
                id="CardEditMedOrderUX-div-15"
                style={{width: "100%"}}>
                {props.DrugSearchBox}
              </div>
            </FormField>
            <FormField
              id="CardEditMedOrderUX-FormField-16"
              style={{paddingLeft:0}}>
              <label
                id="CardEditMedOrderUX-label-21">
                {"\u00a0"}
              </label>
              <Button
                color={props.hasFactSheet ? "blue" : undefined}
                disabled={!props.hasFactSheet}
                fluid={true}
                id="CardEditMedOrderUX-Button-22"
                onClick={props.openFactSheet}
                style={{ whiteSpace: "nowrap"}}>
                DRUG FACT
              </Button>
            </FormField>
            <FormField
              id="CardEditMedOrderUX-FormField-17"
              style={{paddingLeft:0}}>
              <label
                id="CardEditMedOrderUX-label-23">
                {"\u00a0"}
              </label>
              <div
                id="CardEditMedOrderUX-div-24">
                {props.calculatorIcon}
              </div>
            </FormField>
            <FormField
              id="CardEditMedOrderUX-FormField-18"
              style={{paddingLeft:0}}
              width={3}>
              <label
                id="CardEditMedOrderUX-label-25">
                PRN
              </label>
              <Dropdown
                allowAdditions={true}
                className="inline-label"
                clearable={true}
                disabled={!props.selectedDrug }
                fluid={true}
                id="CardEditMedOrderUX-Dropdown-135"
                onAddItem={props.onAdditionPrn}
                onChange={props.ChangeDrugPrn}
                options={props.prnOptions}
                search={true}
                selection={true}
                style={{width: "100%", display: "none"}}
                value={props.drugPrn? props.drugPrn : ""}>
              </Dropdown>
              <div
                id="CardEditMedOrderUX-div-139">
                {props.prnDropdown}
              </div>
            </FormField>
            <FormField
              id="CardEditMedOrderUX-FormField-19"
              style={{ display: props.drugPermission?.config_TPD_ENABLE_IV_COMPATIBLE ? "" : "none",paddingLeft:0}}>
              <label
                id="CardEditMedOrderUX-label-27">
                {"\u00a0"}
              </label>
              <Button
                basic={!props.modSolventSelectionConfig?.activeButtonSolvent}
                color={props.modSolventSelectionConfig?.showButtonSolvent ?"blue": "grey"}
                disabled={!props.modSolventSelectionConfig?.showButtonSolvent }
                fluid={true}
                id="CardEditMedOrderUX-Button-28"
                onClick={props.onOpenModSolventSelection}
                style={{cursor: props.modSolventSelectionConfig?.activeButtonSolvent || typeof props.modSolventSelectionConfig?.admixtureIndex === "number"?"auto":"pointer"}}>
                SOLVENT
              </Button>
            </FormField>
            <FormField
              id="CardEditMedOrderUX-FormField-20"
              style={{display: props.selectedDrug?.original?.is_taper_dose ? "": "none",  fontWeight: "bold",paddingLeft:0 }}>
              <label
                id="CardEditMedOrderUX-label-29">
                {"\u00a0"}
              </label>
              <div
                id="CardEditMedOrderUX-div-30">
                {props.buttonTaperSchedule}
              </div>
            </FormField>
            <FormField
              id="CardEditMedOrderUX-FormField-31"
              style={{flex:1}}>
            </FormField>
            <FormField
              id="CardEditMedOrderUX-FormField-32"
              style={{ display: props.drugPermission?.config_TPD_ENABLE_PTC_DISPENSE  ? "" : "none",paddingLeft:0}}>
              <label
                id="CardEditMedOrderUX-label-34">
                {"\u00a0"}
              </label>
              <Button
                color="blue"
                disabled={!props.enabledButtonDispense}
                id="CardEditMedOrderUX-Button-35"
                onClick={props.onClickDispense}
                style={{minWidth: "max-content"}}>
                ยาแบ่งจ่าย
              </Button>
            </FormField>
            <FormField
              className=" --override-disabled --grey"
              id="CardEditMedOrderUX-FormField-136"
              style={{display: props.showPriority? "": "none"}}>
              <label
                id="CardEditMedOrderUX-label-137">
                Priority
              </label>
              <Dropdown
                disabled={props.disabledPriority}
                fluid={true}
                id="CardEditMedOrderUX-Dropdown-138"
                onChange={props.changePriority}
                options={props.priorityOptions}
                search={true}
                selection={true}
                style={{width: "8rem"}}
                value={props.priority}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardEditMedOrderUX-FormField-33"
              style={{paddingLeft:0}}>
              <label
                id="CardEditMedOrderUX-label-36">
                {"\u00a0"}
              </label>
              <Button
                disabled={props.statusRequest ? false : true}
                icon="file"
                id="CardEditMedOrderUX-Button-37"
                onClick={props.clearDrugOrderForm}
                style={{display: props.showHeader? "none": ""}}>
              </Button>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardEditMedOrderUX-FormGroup-9"
            style={{marginBottom: "0.5rem", paddingRight: "0.25rem"}}>
            <FormField
              className={`required noPadding${props.errorMessage &&!props.drugDose  ? " error" :""}${props.hideDrugForm?.dose ? " hidden": ""}`}
              id="CardEditMedOrderUX-FormField-38"
              width={3}>
              <label
                id="CardEditMedOrderUX-label-48">
                Dose
              </label>
              <div
                id="CardEditMedOrderUX-div-57">
                {props.doseInput}
              </div>
            </FormField>
            <FormField
              className={`required noPadding${props.errorMessage &&!props.selectedDrugUnitId ? " error" :""}${props.hideDrugForm?.unit ? " hidden": ""}`}
              id="CardEditMedOrderUX-FormField-39"
              width={3}>
              <label
                id="CardEditMedOrderUX-label-49">
                Unit
              </label>
              <Dropdown
                className="inline-label"
                disabled={!props.selectedDrug}
                fluid={true}
                id="cb-drugUnit"
                onChange={props.changeDrugUnit}
                options={props.drugUnits}
                search={true}
                selection={true}
                value={props.selectedDrugUnitId}>
              </Dropdown>
            </FormField>
            <FormField
              className={`required noPadding${props.errorMessage &&!props.selectedDrugRouteId ? " error" :""}${props.hideDrugForm?.route ? " hidden": ""}`}
              id="CardEditMedOrderUX-FormField-40"
              width={3}>
              <label
                id="CardEditMedOrderUX-label-50">
                Route
              </label>
              <Dropdown
                className="inline-label"
                disabled={!props.selectedDrug}
                fluid={true}
                id="cb-drugRoute"
                onChange={props.changeDrugRoute}
                options={props.drugRoutes}
                search={true}
                selection={true}
                value={props.selectedDrugRouteId}>
              </Dropdown>
            </FormField>
            <FormField
              className={`required noPadding${props.errorMessage &&!props.selectedDrugSiteId? " error" :"" }${props.hideDrugForm?.site ? " hidden": ""}`}
              id="CardEditMedOrderUX-FormField-41"
              width={3}>
              <label
                id="CardEditMedOrderUX-label-51">
                Site
              </label>
              <Dropdown
                className="inline-label"
                disabled={!props.selectedDrug}
                fluid={true}
                id="cb-drugSite"
                onChange={props.changeDrugSite}
                options={props.drugSites}
                search={true}
                selection={true}
                value={props.selectedDrugSiteId}>
              </Dropdown>
            </FormField>
            <FormField
              className={`required noPadding${props.errorMessage &&!props.selectedDrugFrequencyId? " error" :"" }${props.hideDrugForm?.frequency ? " hidden": ""}${props.disabledFrequency?" --override-disabled --grey": ""}`}
              id="CardEditMedOrderUX-FormField-42"
              width={3}>
              <label
                id="CardEditMedOrderUX-label-52">
                Frequency
              </label>
              <Dropdown
                className="inline-label"
                disabled={!props.selectedDrug || props.disabledFrequency}
                fluid={true}
                id="cb-drugFrequency"
                onChange={props.changeDrugFrequency}
                options={props.drugFrequencies}
                search={true}
                selection={true}
                value={props.selectedDrugFrequencyId}>
              </Dropdown>
            </FormField>
            <FormField
              className={`required noPadding${props.hideDrugForm?.method ? " hidden": ""}`}
              id="CardEditMedOrderUX-FormField-43"
              style={{display: "none"}}
              width={3}>
              <label
                id="CardEditMedOrderUX-label-53">
                Method
              </label>
              <Dropdown
                className="inline-label"
                disabled={!props.selectedDrug}
                fluid={true}
                id="cb-drugMedthod"
                onChange={props.changeDrugMethod}
                options={props.drugMethods}
                search={true}
                selection={true}
                value={props.selectedDrugMethodId}>
              </Dropdown>
            </FormField>
            <FormField
              className={`required noPadding${props.errorMessage &&!props.drugQty? " error" :""}`}
              id="CardEditMedOrderUX-FormField-44"
              width={3}>
              <label
                id="CardEditMedOrderUX-label-54">
                Qty
              </label>
              <Input
                disabled={!props.selectedDrug}
                fluid={true}
                id="txt-drugQty"
                onChange={props.changeDrugQty}
                style={{opacity: 1}}
                value={props.drugQty ? props.drugQty : ""}>
              </Input>
            </FormField>
            <FormField
              className={`${props.noRequiredDuration ? "":"required "}noPadding${props.hideDrugForm?.duration ? " hidden": ""}`}
              id="CardEditMedOrderUX-FormField-45"
              width={3}>
              <label
                id="CardEditMedOrderUX-label-55">
                Duration (วัน)
              </label>
              <Input
                disabled={!props.selectedDrug}
                fluid={true}
                id="txt-drugDuration"
                onChange={props.changeDrugDuration}
                readOnly={props.readOnlyDuration || false}
                style={{opacity: 1}}
                value={props.drugDuration ? props.drugDuration: ""}>
              </Input>
            </FormField>
            <FormField
              className="noPadding"
              id="CardEditMedOrderUX-FormField-46"
              style={{flex: props.drugFormFlexStyle ? 1 : "", minWidth: "150px"}}>
            </FormField>
          </FormGroup>
          <FormGroup
            className="--override-disabled --grey"
            id="CardEditMedOrderUX-FormGroup-66"
            style={{display: props.isRequireRate? "": "none",marginBottom: "0.5rem"}}>
            <FormField
              id="CardEditMedOrderUX-FormField-67"
              width={3}>
              <div
                id="CardEditMedOrderUX-div-131"
                style={{marginBottom: "-1px"}}>
                {props.dripRateLabel}
              </div>
              <Input
                disabled={props.modSolventSelectionConfig?.dripRate !== "rate"}
                fluid={true}
                id="CardEditMedOrderUX-Input-129"
                name="mixture_iv_rate"
                onChange={props.onChangeModData}
                onKeyDown={(e: any)=> ["-","e"].includes(e.key) && e.preventDefault()}
                type="number"
                value={props.modSolventSelectionConfig?.mixture_iv_rate}>
              </Input>
            </FormField>
            <FormField
              id="CardEditMedOrderUX-FormField-68"
              width={3}>
              <label
                id="CardEditMedOrderUX-label-75">
                {"\u00a0"}
              </label>
              <Dropdown
                className="inline-label"
                clearable={true}
                disabled={props.modSolventSelectionConfig?.dripRate !== "rate"}
                fluid={true}
                id="CardEditMedOrderUX-Dropdown-82"
                name="mixture_iv_rate_unit"
                onChange={props.onChangeModData}
                options={props.modSolventSelectionConfig?.ivRateOptions || []}
                search={true}
                selection={true}
                value={props.modSolventSelectionConfig?.mixture_iv_rate_unit}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardEditMedOrderUX-FormField-69"
              width={3}>
              <div
                id="CardEditMedOrderUX-div-130"
                style={{marginBottom: "-1px"}}>
                {props.dripDurationLabel}
              </div>
              <Input
                disabled={props.modSolventSelectionConfig?.dripRate === "rate"}
                fluid={true}
                id="CardEditMedOrderUX-Input-81"
                name="drug_drip_in"
                onChange={props.onChangeModData}
                onKeyDown={(e: any)=> ["-","e"].includes(e.key) && e.preventDefault()}
                type="number"
                value={props.modSolventSelectionConfig?.drug_drip_in}>
              </Input>
            </FormField>
            <FormField
              id="CardEditMedOrderUX-FormField-70"
              width={3}>
              <label
                id="CardEditMedOrderUX-label-74">
                {"\u00a0"}
              </label>
              <Dropdown
                className="inline-label"
                clearable={true}
                disabled={props.modSolventSelectionConfig?.dripRate === "rate"}
                fluid={true}
                id="CardEditMedOrderUX-Dropdown-83"
                name="drug_drip_in_unit"
                onChange={props.onChangeModData}
                options={props.modSolventSelectionConfig?.dripInOptions || []}
                search={true}
                selection={true}
                value={props.modSolventSelectionConfig?.drug_drip_in_unit}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardEditMedOrderUX-FormField-133"
              width={(Object.values(props.hideDrugForm||{}).filter(Boolean).length - 2)*3}>
            </FormField>
            <FormField
              id="CardEditMedOrderUX-FormField-134"
              style={{minWidth: "150px"}}>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardEditMedOrderUX-FormGroup-116"
            style={{display:props.errorPediatricData? "": "none", marginBottom: "0.25rem"}}>
            <FormField
              id="CardEditMedOrderUX-FormField-117">
              <div
                id="CardEditMedOrderUX-div-118">
                {props.pediatricWarning}
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardEditMedOrderUX-FormGroup-109"
            style={{ display: props.hideDrugDescription ? "none" : "",marginBottom: "0.5rem", paddingRight: "0.25rem"}}>
            <FormField
              id="CardEditMedOrderUX-FormField-110"
              width={14}>
              <label
                id="CardEditMedOrderUX-label-111">
                Description
              </label>
              <Input
                disabled={!props.selectedDrug}
                fluid={true}
                id="txt-drugDescription"
                onChange={props.changeDrugDescription}
                style={{opacity: 1}}
                value={props.drugDescription || ""}>
              </Input>
            </FormField>
            <FormField
              id="CardEditMedOrderUX-FormField-113"
              style={{minWidth: "150px"}}>
              <label
                id="CardEditMedOrderUX-label-114">
                {"\u00a0"}
              </label>
              <div
                id="CardEditMedOrderUX-div-115"
                style={{display: props.hideSolvent? "": "none"}}>
                {props.buttonAddToOrder}
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardEditMedOrderUX-FormGroup-91"
            style={{display: props.hideSolvent? "none": "",marginBottom: "0.5rem"}}>
            <FormField
              id="CardEditMedOrderUX-FormField-92"
              style={{ border: "1px solid rgba(34,36,38,.15)",borderRight: "none", paddingTop: "1rem", paddingBottom: "1rem" }}
              width={6}>
              <label
                id="CardEditMedOrderUX-label-96">
                Solvent
              </label>
              <div
                id="CardEditMedOrderUX-div-132">
                {props.searchBoxSolvent}
              </div>
            </FormField>
            <FormField
              id="CardEditMedOrderUX-FormField-93"
              style={{ border: "1px solid rgba(34,36,38,.15)",borderRight: "none", paddingTop: "1rem", paddingBottom: "1rem" , borderLeft: "none"}}
              width={2}>
              <label
                id="CardEditMedOrderUX-label-97">
                Volume (For mixing)
              </label>
              <Input
                fluid={true}
                id="CardEditMedOrderUX-Input-102"
                name="volume"
                onChange={props.onChangeModData}
                onKeyDown={(e: any)=> ["-","e"].includes(e.key) && e.preventDefault()}
                type="number"
                value={props.modSolventSelectionConfig?.volume  ?? ""}>
              </Input>
            </FormField>
            <FormField
              id="CardEditMedOrderUX-FormField-94"
              style={{ border: "1px solid rgba(34,36,38,.15)",borderRight: "none", paddingTop: "1rem", paddingBottom: "1rem" , borderLeft: "none"}}
              width={2}>
              <label
                id="CardEditMedOrderUX-label-98">
                Unit (of volume)
              </label>
              <Dropdown
                className="inline-label"
                fluid={true}
                id="CardEditMedOrderUX-Dropdown-101"
                name="unit"
                onChange={props.onChangeModData}
                options={props.unitOptions}
                search={true}
                selection={true}
                value={props.modSolventSelectionConfig?.unit || ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardEditMedOrderUX-FormField-95"
              style={{ border: "1px solid rgba(34,36,38,.15)",borderRight: "none", paddingTop: "1rem", paddingBottom: "1rem" , borderLeft: "none"}}
              width={2}>
              <label
                id="CardEditMedOrderUX-label-99"
                style={{minWidth: "max-content"}}>
                Total Qty (per dispense)
              </label>
              <Input
                fluid={true}
                id="CardEditMedOrderUX-Input-103"
                name="quantity"
                onChange={props.onChangeModData}
                onKeyDown={(e: any)=> ["-","e"].includes(e.key) && e.preventDefault()}
                type="number"
                value={props.modSolventSelectionConfig?.quantity ?? ""}>
              </Input>
            </FormField>
            <FormField
              id="CardEditMedOrderUX-FormField-104"
              style={{ border: "1px solid rgba(34,36,38,.15)",borderLeft: "none", paddingTop: "1rem", paddingBottom: "1rem", position: "relative", flex:1, marginRight: props.showHeader?"0.75rem":"" }}>
              <div
                id="CardEditMedOrderUX-div-121"
                style={{position: "absolute", top: "0", right: "0.25rem", display: typeof props.modSolventSelectionConfig?.admixtureIndex === "number"?"none":""}}>

                <Icon
                  className="red small"
                  id="CardEditMedOrderUX-Icon-122"
                  link={true}
                  name="close"
                  onClick={props.onCloseButtonSolvent}>
                </Icon>
              </div>
            </FormField>
            <FormField
              id="CardEditMedOrderUX-FormField-105"
              style={{display: props.hideSolvent? "none": "", margin: "auto", minWidth: "150px"}}>
              <label
                id="CardEditMedOrderUX-label-123"
                style={{margin: 0}}>
                {"\u00a0"}
              </label>
              <div
                id="CardEditMedOrderUX-div-106">
                {props.buttonAddToOrder}
              </div>
            </FormField>
          </FormGroup>
        </div>
      </div>
    )
}

CardEditMedOrderUX.displayName = "CardEditMedOrderUX";
export default React.memo(CardEditMedOrderUX)

export const screenPropsDefault = {}

/* Date Time : Fri Feb 07 2025 12:27:06 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\", padding: \"10px\",  height: \"100%\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{display: props.showHeader? \"flex\": \"none\", justifyContent: \"space-between\", alignItems: \"center\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui divider"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{display: props.showHeader? \"\": \"none\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "แก้ไขคำสั่งยา"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"1.15rem\", fontWeight: \"bold\", padding: \"2.5px 0\", color: \"#0072BC\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-div-4"
        },
        "style": {
          "type": "code",
          "value": "{cursor: \"pointer\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "Icon",
      "parent": 4,
      "props": {
        "className": {
          "type": "value",
          "value": "red"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-Icon-5"
        },
        "name": {
          "type": "value",
          "value": "close"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClose"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 6,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-div-6"
        },
        "style": {
          "type": "code",
          "value": "{ position: \"relative\", padding: props.showHeader? \"0 0.5rem\": \"\"}"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "FormGroup",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-FormGroup-8"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"0.5rem\"}"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "FormGroup",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-FormGroup-9"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"0.5rem\", paddingRight: \"0.25rem\"}"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "FormField",
      "parent": 8,
      "props": {
        "className": {
          "type": "value",
          "value": "--override-disabled --grey"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-FormField-12"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 13,
      "name": "FormField",
      "parent": 12,
      "props": {
        "className": {
          "type": "value",
          "value": "required"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-FormField-13"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "label",
      "parent": 13,
      "props": {
        "children": {
          "type": "value",
          "value": "Drug"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-label-14"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "div",
      "parent": 12,
      "props": {
        "children": {
          "type": "code",
          "value": "props.DrugSearchBox"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-div-15"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 16,
      "name": "FormField",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-FormField-16"
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft:0}"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 17,
      "name": "FormField",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-FormField-17"
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft:0}"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 18,
      "name": "FormField",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-FormField-18"
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft:0}"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 19,
      "name": "FormField",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-FormField-19"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.drugPermission?.config_TPD_ENABLE_IV_COMPATIBLE ? \"\" : \"none\",paddingLeft:0}"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 20,
      "name": "FormField",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-FormField-20"
        },
        "style": {
          "type": "code",
          "value": "{display: props.selectedDrug?.original?.is_taper_dose ? \"\": \"none\",  fontWeight: \"bold\",paddingLeft:0 }"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": null,
      "id": 21,
      "name": "label",
      "parent": 16,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-label-21"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "Button",
      "parent": 16,
      "props": {
        "children": {
          "type": "value",
          "value": "DRUG FACT"
        },
        "color": {
          "type": "code",
          "value": "props.hasFactSheet ? \"blue\" : undefined"
        },
        "disabled": {
          "type": "code",
          "value": "!props.hasFactSheet"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-Button-22"
        },
        "onClick": {
          "type": "code",
          "value": "props.openFactSheet"
        },
        "style": {
          "type": "code",
          "value": "{ whiteSpace: \"nowrap\"}"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 23,
      "name": "label",
      "parent": 17,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-label-23"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": null,
      "id": 24,
      "name": "div",
      "parent": 17,
      "props": {
        "children": {
          "type": "code",
          "value": "props.calculatorIcon"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-div-24"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": null,
      "id": 25,
      "name": "label",
      "parent": 18,
      "props": {
        "children": {
          "type": "value",
          "value": "PRN"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-label-25"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": null,
      "id": 27,
      "name": "label",
      "parent": 19,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-label-27"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 28,
      "name": "Button",
      "parent": 19,
      "props": {
        "basic": {
          "type": "code",
          "value": "!props.modSolventSelectionConfig?.activeButtonSolvent"
        },
        "children": {
          "type": "value",
          "value": "SOLVENT"
        },
        "color": {
          "type": "code",
          "value": "props.modSolventSelectionConfig?.showButtonSolvent ?\"blue\": \"grey\""
        },
        "disabled": {
          "type": "code",
          "value": "!props.modSolventSelectionConfig?.showButtonSolvent "
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-Button-28"
        },
        "onClick": {
          "type": "code",
          "value": "props.onOpenModSolventSelection"
        },
        "style": {
          "type": "code",
          "value": "{cursor: props.modSolventSelectionConfig?.activeButtonSolvent || typeof props.modSolventSelectionConfig?.admixtureIndex === \"number\"?\"auto\":\"pointer\"}"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": null,
      "id": 29,
      "name": "label",
      "parent": 20,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-label-29"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": null,
      "id": 30,
      "name": "div",
      "parent": 20,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonTaperSchedule"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-div-30"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 31,
      "name": "FormField",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-FormField-31"
        },
        "style": {
          "type": "code",
          "value": "{flex:1}"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 32,
      "name": "FormField",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-FormField-32"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.drugPermission?.config_TPD_ENABLE_PTC_DISPENSE  ? \"\" : \"none\",paddingLeft:0}"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 33,
      "name": "FormField",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-FormField-33"
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft:0}"
        }
      },
      "seq": 136,
      "void": false
    },
    {
      "from": null,
      "id": 34,
      "name": "label",
      "parent": 32,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-label-34"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 35,
      "name": "Button",
      "parent": 32,
      "props": {
        "children": {
          "type": "value",
          "value": "ยาแบ่งจ่าย"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "disabled": {
          "type": "code",
          "value": "!props.enabledButtonDispense"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-Button-35"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickDispense"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": null,
      "id": 36,
      "name": "label",
      "parent": 33,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-label-36"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 37,
      "name": "Button",
      "parent": 33,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.statusRequest ? false : true"
        },
        "icon": {
          "type": "value",
          "value": "file"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-Button-37"
        },
        "onClick": {
          "type": "code",
          "value": "props.clearDrugOrderForm"
        },
        "style": {
          "type": "code",
          "value": "{display: props.showHeader? \"none\": \"\"}"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 38,
      "name": "FormField",
      "parent": 9,
      "props": {
        "className": {
          "type": "code",
          "value": "`required noPadding${props.errorMessage &&!props.drugDose  ? \" error\" :\"\"}${props.hideDrugForm?.dose ? \" hidden\": \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-FormField-38"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 39,
      "name": "FormField",
      "parent": 9,
      "props": {
        "className": {
          "type": "code",
          "value": "`required noPadding${props.errorMessage &&!props.selectedDrugUnitId ? \" error\" :\"\"}${props.hideDrugForm?.unit ? \" hidden\": \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-FormField-39"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 40,
      "name": "FormField",
      "parent": 9,
      "props": {
        "className": {
          "type": "code",
          "value": "`required noPadding${props.errorMessage &&!props.selectedDrugRouteId ? \" error\" :\"\"}${props.hideDrugForm?.route ? \" hidden\": \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-FormField-40"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 41,
      "name": "FormField",
      "parent": 9,
      "props": {
        "className": {
          "type": "code",
          "value": "`required noPadding${props.errorMessage &&!props.selectedDrugSiteId? \" error\" :\"\" }${props.hideDrugForm?.site ? \" hidden\": \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-FormField-41"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 42,
      "name": "FormField",
      "parent": 9,
      "props": {
        "className": {
          "type": "code",
          "value": "`required noPadding${props.errorMessage &&!props.selectedDrugFrequencyId? \" error\" :\"\" }${props.hideDrugForm?.frequency ? \" hidden\": \"\"}${props.disabledFrequency?\" --override-disabled --grey\": \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-FormField-42"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 43,
      "name": "FormField",
      "parent": 9,
      "props": {
        "className": {
          "type": "code",
          "value": "`required noPadding${props.hideDrugForm?.method ? \" hidden\": \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-FormField-43"
        },
        "style": {
          "type": "code",
          "value": "{display: \"none\"}"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 44,
      "name": "FormField",
      "parent": 9,
      "props": {
        "className": {
          "type": "code",
          "value": "`required noPadding${props.errorMessage &&!props.drugQty? \" error\" :\"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-FormField-44"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 45,
      "name": "FormField",
      "parent": 9,
      "props": {
        "className": {
          "type": "code",
          "value": "`${props.noRequiredDuration ? \"\":\"required \"}noPadding${props.hideDrugForm?.duration ? \" hidden\": \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-FormField-45"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 46,
      "name": "FormField",
      "parent": 9,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-FormField-46"
        },
        "style": {
          "type": "code",
          "value": "{flex: props.drugFormFlexStyle ? 1 : \"\", minWidth: \"150px\"}"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": null,
      "id": 48,
      "name": "label",
      "parent": 38,
      "props": {
        "children": {
          "type": "value",
          "value": "Dose"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-label-48"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": null,
      "id": 49,
      "name": "label",
      "parent": 39,
      "props": {
        "children": {
          "type": "value",
          "value": "Unit"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-label-49"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": null,
      "id": 50,
      "name": "label",
      "parent": 40,
      "props": {
        "children": {
          "type": "value",
          "value": "Route"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-label-50"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": null,
      "id": 51,
      "name": "label",
      "parent": 41,
      "props": {
        "children": {
          "type": "value",
          "value": "Site"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-label-51"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": null,
      "id": 52,
      "name": "label",
      "parent": 42,
      "props": {
        "children": {
          "type": "value",
          "value": "Frequency"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-label-52"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": null,
      "id": 53,
      "name": "label",
      "parent": 43,
      "props": {
        "children": {
          "type": "value",
          "value": "Method"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-label-53"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": null,
      "id": 54,
      "name": "label",
      "parent": 44,
      "props": {
        "children": {
          "type": "value",
          "value": "Qty"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-label-54"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": null,
      "id": 55,
      "name": "label",
      "parent": 45,
      "props": {
        "children": {
          "type": "value",
          "value": "Duration (วัน)"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-label-55"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": null,
      "id": 57,
      "name": "div",
      "parent": 38,
      "props": {
        "children": {
          "type": "code",
          "value": "props.doseInput"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-div-57"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 58,
      "name": "Dropdown",
      "parent": 39,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "disabled": {
          "type": "code",
          "value": "!props.selectedDrug"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "cb-drugUnit"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeDrugUnit"
        },
        "options": {
          "type": "code",
          "value": "props.drugUnits"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.selectedDrugUnitId"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 59,
      "name": "Dropdown",
      "parent": 40,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "disabled": {
          "type": "code",
          "value": "!props.selectedDrug"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "cb-drugRoute"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeDrugRoute"
        },
        "options": {
          "type": "code",
          "value": "props.drugRoutes"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.selectedDrugRouteId"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 60,
      "name": "Dropdown",
      "parent": 41,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "disabled": {
          "type": "code",
          "value": "!props.selectedDrug"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "cb-drugSite"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeDrugSite"
        },
        "options": {
          "type": "code",
          "value": "props.drugSites"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.selectedDrugSiteId"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 61,
      "name": "Dropdown",
      "parent": 42,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "disabled": {
          "type": "code",
          "value": "!props.selectedDrug || props.disabledFrequency"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "cb-drugFrequency"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeDrugFrequency"
        },
        "options": {
          "type": "code",
          "value": "props.drugFrequencies"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.selectedDrugFrequencyId"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 62,
      "name": "Dropdown",
      "parent": 43,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "disabled": {
          "type": "code",
          "value": "!props.selectedDrug"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "cb-drugMedthod"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeDrugMethod"
        },
        "options": {
          "type": "code",
          "value": "props.drugMethods"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.selectedDrugMethodId"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 63,
      "name": "Input",
      "parent": 44,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.selectedDrug"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "txt-drugQty"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeDrugQty"
        },
        "style": {
          "type": "code",
          "value": "{opacity: 1}"
        },
        "value": {
          "type": "code",
          "value": "props.drugQty ? props.drugQty : \"\""
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 64,
      "name": "Input",
      "parent": 45,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.selectedDrug"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "txt-drugDuration"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeDrugDuration"
        },
        "readOnly": {
          "type": "code",
          "value": "props.readOnlyDuration || false"
        },
        "style": {
          "type": "code",
          "value": "{opacity: 1}"
        },
        "value": {
          "type": "code",
          "value": "props.drugDuration ? props.drugDuration: \"\""
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 66,
      "name": "FormGroup",
      "parent": 6,
      "props": {
        "className": {
          "type": "value",
          "value": "--override-disabled --grey"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-FormGroup-66"
        },
        "style": {
          "type": "code",
          "value": "{display: props.isRequireRate? \"\": \"none\",marginBottom: \"0.5rem\"}"
        }
      },
      "seq": 91,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 67,
      "name": "FormField",
      "parent": 66,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-FormField-67"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 68,
      "name": "FormField",
      "parent": 66,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-FormField-68"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 69,
      "name": "FormField",
      "parent": 66,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-FormField-69"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 70,
      "name": "FormField",
      "parent": 66,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-FormField-70"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": null,
      "id": 74,
      "name": "label",
      "parent": 70,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-label-74"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 74,
      "void": false
    },
    {
      "from": null,
      "id": 75,
      "name": "label",
      "parent": 68,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-label-75"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 75,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 81,
      "name": "Input",
      "parent": 69,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.modSolventSelectionConfig?.dripRate === \"rate\""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-Input-81"
        },
        "name": {
          "type": "value",
          "value": "drug_drip_in"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeModData"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any)=> [\"-\",\"e\"].includes(e.key) && e.preventDefault()"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.modSolventSelectionConfig?.drug_drip_in"
        }
      },
      "seq": 130,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 82,
      "name": "Dropdown",
      "parent": 68,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.modSolventSelectionConfig?.dripRate !== \"rate\""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-Dropdown-82"
        },
        "name": {
          "type": "value",
          "value": "mixture_iv_rate_unit"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeModData"
        },
        "options": {
          "type": "code",
          "value": "props.modSolventSelectionConfig?.ivRateOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.modSolventSelectionConfig?.mixture_iv_rate_unit"
        }
      },
      "seq": 82,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 83,
      "name": "Dropdown",
      "parent": 70,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.modSolventSelectionConfig?.dripRate === \"rate\""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-Dropdown-83"
        },
        "name": {
          "type": "value",
          "value": "drug_drip_in_unit"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeModData"
        },
        "options": {
          "type": "code",
          "value": "props.modSolventSelectionConfig?.dripInOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.modSolventSelectionConfig?.drug_drip_in_unit"
        }
      },
      "seq": 83,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 91,
      "name": "FormGroup",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-FormGroup-91"
        },
        "style": {
          "type": "code",
          "value": "{display: props.hideSolvent? \"none\": \"\",marginBottom: \"0.5rem\"}"
        }
      },
      "seq": 120,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 92,
      "name": "FormField",
      "parent": 91,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-FormField-92"
        },
        "style": {
          "type": "code",
          "value": "{ border: \"1px solid rgba(34,36,38,.15)\",borderRight: \"none\", paddingTop: \"1rem\", paddingBottom: \"1rem\" }"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 92,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 93,
      "name": "FormField",
      "parent": 91,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-FormField-93"
        },
        "style": {
          "type": "code",
          "value": "{ border: \"1px solid rgba(34,36,38,.15)\",borderRight: \"none\", paddingTop: \"1rem\", paddingBottom: \"1rem\" , borderLeft: \"none\"}"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 93,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 94,
      "name": "FormField",
      "parent": 91,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-FormField-94"
        },
        "style": {
          "type": "code",
          "value": "{ border: \"1px solid rgba(34,36,38,.15)\",borderRight: \"none\", paddingTop: \"1rem\", paddingBottom: \"1rem\" , borderLeft: \"none\"}"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 94,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 95,
      "name": "FormField",
      "parent": 91,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-FormField-95"
        },
        "style": {
          "type": "code",
          "value": "{ border: \"1px solid rgba(34,36,38,.15)\",borderRight: \"none\", paddingTop: \"1rem\", paddingBottom: \"1rem\" , borderLeft: \"none\"}"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 95,
      "void": false
    },
    {
      "from": null,
      "id": 96,
      "name": "label",
      "parent": 92,
      "props": {
        "children": {
          "type": "value",
          "value": "Solvent"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-label-96"
        }
      },
      "seq": 96,
      "void": false
    },
    {
      "from": null,
      "id": 97,
      "name": "label",
      "parent": 93,
      "props": {
        "children": {
          "type": "value",
          "value": "Volume (For mixing)"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-label-97"
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": null,
      "id": 98,
      "name": "label",
      "parent": 94,
      "props": {
        "children": {
          "type": "value",
          "value": "Unit (of volume)"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-label-98"
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": null,
      "id": 99,
      "name": "label",
      "parent": 95,
      "props": {
        "children": {
          "type": "value",
          "value": "Total Qty (per dispense)"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-label-99"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 99,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 101,
      "name": "Dropdown",
      "parent": 94,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-Dropdown-101"
        },
        "name": {
          "type": "value",
          "value": "unit"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeModData"
        },
        "options": {
          "type": "code",
          "value": "props.unitOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.modSolventSelectionConfig?.unit || \"\""
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 102,
      "name": "Input",
      "parent": 93,
      "props": {
        "disabled": {
          "type": "code",
          "value": ""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-Input-102"
        },
        "name": {
          "type": "value",
          "value": "volume"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeModData"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any)=> [\"-\",\"e\"].includes(e.key) && e.preventDefault()"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.modSolventSelectionConfig?.volume  ?? \"\""
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 103,
      "name": "Input",
      "parent": 95,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-Input-103"
        },
        "name": {
          "type": "value",
          "value": "quantity"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeModData"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any)=> [\"-\",\"e\"].includes(e.key) && e.preventDefault()"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.modSolventSelectionConfig?.quantity ?? \"\""
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 104,
      "name": "FormField",
      "parent": 91,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-FormField-104"
        },
        "style": {
          "type": "code",
          "value": "{ border: \"1px solid rgba(34,36,38,.15)\",borderLeft: \"none\", paddingTop: \"1rem\", paddingBottom: \"1rem\", position: \"relative\", flex:1, marginRight: props.showHeader?\"0.75rem\":\"\" }"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 104,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 105,
      "name": "FormField",
      "parent": 91,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-FormField-105"
        },
        "style": {
          "type": "code",
          "value": "{display: props.hideSolvent? \"none\": \"\", margin: \"auto\", minWidth: \"150px\"}"
        }
      },
      "seq": 105,
      "void": false
    },
    {
      "from": null,
      "id": 106,
      "name": "div",
      "parent": 105,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonAddToOrder"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-div-106"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 123,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 109,
      "name": "FormGroup",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-FormGroup-109"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.hideDrugDescription ? \"none\" : \"\",marginBottom: \"0.5rem\", paddingRight: \"0.25rem\"}"
        }
      },
      "seq": 116,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 110,
      "name": "FormField",
      "parent": 109,
      "props": {
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-FormField-110"
        },
        "width": {
          "type": "code",
          "value": "14"
        }
      },
      "seq": 110,
      "void": false
    },
    {
      "from": null,
      "id": 111,
      "name": "label",
      "parent": 110,
      "props": {
        "children": {
          "type": "value",
          "value": "Description"
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-label-111"
        }
      },
      "seq": 111,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 112,
      "name": "Input",
      "parent": 110,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.selectedDrug"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "txt-drugDescription"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeDrugDescription"
        },
        "style": {
          "type": "code",
          "value": "{opacity: 1}"
        },
        "value": {
          "type": "code",
          "value": "props.drugDescription || \"\""
        }
      },
      "seq": 112,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 113,
      "name": "FormField",
      "parent": 109,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-FormField-113"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"150px\"}"
        }
      },
      "seq": 113,
      "void": false
    },
    {
      "from": null,
      "id": 114,
      "name": "label",
      "parent": 113,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-label-114"
        }
      },
      "seq": 114,
      "void": false
    },
    {
      "from": null,
      "id": 115,
      "name": "div",
      "parent": 113,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonAddToOrder"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-div-115"
        },
        "style": {
          "type": "code",
          "value": "{display: props.hideSolvent? \"\": \"none\"}"
        }
      },
      "seq": 115,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 116,
      "name": "FormGroup",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-FormGroup-116"
        },
        "style": {
          "type": "code",
          "value": "{display:props.errorPediatricData? \"\": \"none\", marginBottom: \"0.25rem\"}"
        }
      },
      "seq": 109,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 117,
      "name": "FormField",
      "parent": 116,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-FormField-117"
        }
      },
      "seq": 117,
      "void": false
    },
    {
      "from": null,
      "id": 118,
      "name": "div",
      "parent": 117,
      "props": {
        "children": {
          "type": "code",
          "value": "props.pediatricWarning"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-div-118"
        }
      },
      "seq": 118,
      "void": false
    },
    {
      "from": null,
      "id": 120,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "code",
          "value": "props.pediatricUI"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-div-120"
        },
        "style": {
          "type": "code",
          "value": "{display: props.openCalCulator ? \"inline\" : \"none\", position:\"absolute\", width:\"80%\", height:\"180px\", right:\"16px\", top:\"-35rem\"}"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 121,
      "name": "div",
      "parent": 104,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-div-121"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", top: \"0\", right: \"0.25rem\", display: typeof props.modSolventSelectionConfig?.admixtureIndex === \"number\"?\"none\":\"\"}"
        }
      },
      "seq": 121,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 122,
      "name": "Icon",
      "parent": 121,
      "props": {
        "className": {
          "type": "value",
          "value": "red small"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-Icon-122"
        },
        "link": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "close"
        },
        "onClick": {
          "type": "code",
          "value": "props.onCloseButtonSolvent"
        }
      },
      "seq": 122,
      "void": false
    },
    {
      "from": null,
      "id": 123,
      "name": "label",
      "parent": 105,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-label-123"
        },
        "style": {
          "type": "code",
          "value": "{margin: 0}"
        }
      },
      "seq": 106,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 129,
      "name": "Input",
      "parent": 67,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.modSolventSelectionConfig?.dripRate !== \"rate\""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-Input-129"
        },
        "name": {
          "type": "value",
          "value": "mixture_iv_rate"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeModData"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any)=> [\"-\",\"e\"].includes(e.key) && e.preventDefault()"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.modSolventSelectionConfig?.mixture_iv_rate"
        }
      },
      "seq": 131,
      "void": false
    },
    {
      "from": null,
      "id": 130,
      "name": "div",
      "parent": 69,
      "props": {
        "children": {
          "type": "code",
          "value": "props.dripDurationLabel"
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-div-130"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"-1px\"}"
        }
      },
      "seq": 88,
      "void": false
    },
    {
      "from": null,
      "id": 131,
      "name": "div",
      "parent": 67,
      "props": {
        "children": {
          "type": "code",
          "value": "props.dripRateLabel"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-div-131"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"-1px\"}"
        }
      },
      "seq": 129,
      "void": false
    },
    {
      "from": null,
      "id": 132,
      "name": "div",
      "parent": 92,
      "props": {
        "children": {
          "type": "code",
          "value": "props.searchBoxSolvent"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-div-132"
        }
      },
      "seq": 132,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 133,
      "name": "FormField",
      "parent": 66,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-FormField-133"
        },
        "width": {
          "type": "code",
          "value": "(Object.values(props.hideDrugForm||{}).filter(Boolean).length - 2)*3"
        }
      },
      "seq": 133,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 134,
      "name": "FormField",
      "parent": 66,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-FormField-134"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"150px\"}"
        }
      },
      "seq": 134,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 135,
      "name": "Dropdown",
      "parent": 18,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "!props.selectedDrug "
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-Dropdown-135"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAdditionPrn"
        },
        "onChange": {
          "type": "code",
          "value": "props.ChangeDrugPrn"
        },
        "options": {
          "type": "code",
          "value": "props.prnOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", display: \"none\"}"
        },
        "value": {
          "type": "code",
          "value": "props.drugPrn? props.drugPrn : \"\""
        }
      },
      "seq": 135,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 136,
      "name": "FormField",
      "parent": 8,
      "props": {
        "className": {
          "type": "value",
          "value": " --override-disabled --grey"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-FormField-136"
        },
        "style": {
          "type": "code",
          "value": "{display: props.showPriority? \"\": \"none\"}"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": null,
      "id": 137,
      "name": "label",
      "parent": 136,
      "props": {
        "children": {
          "type": "value",
          "value": "Priority"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-label-137"
        }
      },
      "seq": 137,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 138,
      "name": "Dropdown",
      "parent": 136,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.disabledPriority"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-Dropdown-138"
        },
        "onChange": {
          "type": "code",
          "value": "props.changePriority"
        },
        "options": {
          "type": "code",
          "value": "props.priorityOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"8rem\"}"
        },
        "value": {
          "type": "code",
          "value": "props.priority"
        }
      },
      "seq": 138,
      "void": false
    },
    {
      "from": null,
      "id": 139,
      "name": "div",
      "parent": 18,
      "props": {
        "children": {
          "type": "code",
          "value": "props.prnDropdown"
        },
        "id": {
          "type": "value",
          "value": "CardEditMedOrderUX-div-139"
        }
      },
      "seq": 139,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": true,
  "name": "CardEditMedOrderUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
